import { GithubOutlined } from '@ant-design/icons';
import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      links={[]} // 清空 links 属性
      copyright="Copyright © 2020-2024 沈阳东软智能医疗科技研究院有限公司" 
    />
  );
};

export default Footer;
